import { Button } from '@synoptic/ui-kit/button/button.tsx';
import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.tsx';
import { FC, ReactNode } from 'react';
import { useLocation } from 'react-router';
import { getRedirectLink } from '@/routes-utils/get-redirect-link.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import {
  authButtonsBox,
  modalContent,
  modalDescription,
  modalTitle,
} from '../unauthenticated-post-card/unauthenticated-post-card.css.ts';

export type UnauthenticatedActionModalProps = {
  trigger?: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const UnauthenticatedActionModal: FC<
  UnauthenticatedActionModalProps
> = ({ trigger, onOpenChange, open }) => {
  const location = useLocation();

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalTrigger asChild>{trigger}</ModalTrigger>
      <ModalContent className={modalContent}>
        <ModalHeader>
          <ModalTitle className={modalTitle}>Hold on!</ModalTitle>
        </ModalHeader>
        <div>
          <span className={modalDescription}>
            To continue, you&apos;ll need to log in or create an account. It
            just takes a moment, and it helps us keep your experience secure and
            personalized.
          </span>
          <div className={authButtonsBox}>
            <Button size={'large'} asChild>
              <Link to={getRedirectLink(paths.signup, location.pathname)}>
                Sign up
              </Link>
            </Button>
            <Button size={'large'} variant={'secondary'} asChild>
              <Link to={getRedirectLink(paths.login, location.pathname)}>
                Log in
              </Link>
            </Button>
          </div>
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
